// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b9256582","884":"e233ac76"}[chunkId] + ".chunk.js";
};